import { render, staticRenderFns } from "./StudentOverview.vue?vue&type=template&id=47f04e71&scoped=true"
import script from "./StudentOverview.vue?vue&type=script&lang=js"
export * from "./StudentOverview.vue?vue&type=script&lang=js"
import style0 from "./StudentOverview.vue?vue&type=style&index=0&id=47f04e71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f04e71",
  null
  
)

export default component.exports